/* The Gilded Gallery: product page lower sections (sections/gg-pdp-*.liquid).
   - "Add the trio": adds this painting + its two partners in the Frame + Size chosen in the picker, in ONE /cart/add.js request,
     then refreshes the cart bubble + drawer like North's Add to Cart (cart-bubble / cart-side sections, then a #quick_cart click).
     The picker's bundle bar (cf-variant-ui) watches /cart/ requests and refreshes itself.
   - Size guide buttons; FAQ opens when its block is selected in the theme editor.
   Handlers are delegated on document and bound once, so theme-editor section reloads never duplicate them. */
(function () {
  "use strict";
  if (window.__ggPdp) { window.__ggPdp.scan(); return; }

  function q(root, sel) { return root ? root.querySelector(sel) : null; }
  function data(root) {
    if (root.__ggData) return root.__ggData;
    try { root.__ggData = JSON.parse(q(root, "[data-gg-trio-data]").textContent); } catch (e) { root.__ggData = null; }
    return root.__ggData;
  }
  function sizeText(s, unit) { return String(s || "").replace(/\s*x\s*/i, " × ") + (unit ? " " + unit : ""); }
  function fill(t, map) { return String(t || "").replace(/\[(\w+)\]/g, function (m, k) { return map[k] != null ? map[k] : m; }); }

  // Current Frame + Size from the main product form (the picker keeps these native selects in sync).
  function selection(root, d) {
    var pid = root.getAttribute("data-product-id");
    var form = document.querySelector('.thb-product-detail[data-id="' + pid + '"]') || document;
    var s1 = q(form, '.js-product-options select[data-option="option1"]'), s2 = q(form, '.js-product-options select[data-option="option2"]');
    if (s1 && s2 && s1.value && s2.value) return [s1.value, s2.value];
    var idIn = q(form, ".js-product-options .js-product-variant-id-input"), cur = d.pieces[0];
    if (idIn && cur) for (var k in cur.variants) if (String(cur.variants[k][0]) === String(idIn.value)) return k.split("|");
    return d.selected;
  }

  // Variant ids to add: exact Frame + Size for all three; a partner without it falls back to the same Frame at the fallback size.
  function plan(root) {
    var d = data(root); if (!d) return null;
    var sel = selection(root, d), key = sel[0] + "|" + sel[1], fbKey = sel[0] + "|" + d.fallbackSize;
    var ids = [], notes = [], ok = true;
    d.pieces.forEach(function (pc) {
      var v = pc.variants[key];
      if (v && v[1]) { ids.push(v[0]); return; }
      var f = pc.variants[fbKey];
      if (!pc.current && sel[1] !== d.fallbackSize && f && f[1]) {
        ids.push(f[0]);
        notes.push(fill(d.strings.fallback, { title: pc.title, size: sizeText(sel[1], d.strings.unit), fallback: sizeText(d.fallbackSize, d.strings.unit) }));
        return;
      }
      ok = false;
    });
    return { ok: ok && ids.length === d.pieces.length, ids: ids, notes: notes, sel: sel, d: d };
  }

  function render(root) {
    var p = plan(root); if (!p) return;
    var selEl = q(root, "[data-gg-trio-sel]"), note = q(root, "[data-gg-trio-note]"), btn = q(root, "[data-gg-trio-add]");
    if (selEl) selEl.textContent = p.sel[0] + " · " + sizeText(p.sel[1], p.d.strings.unit);
    var msg = p.ok ? p.notes.join(" ") : p.d.strings.unavailable;
    if (note) { note.textContent = msg; note.hidden = !msg; }
    if (btn && !root.__ggBusy) btn.disabled = !p.ok;
  }

  // Same targets as North's add-to-cart success handler; nodes are moved over (like the cart drawer's own qty stepper), scripts dropped.
  function swapInto(html, srcSel, dstSel) {
    var dst = document.querySelector(dstSel); if (!dst || !html) return;
    var src = new DOMParser().parseFromString(html, "text/html").querySelector(srcSel); if (!src) return;
    Array.prototype.forEach.call(src.querySelectorAll("script"), function (s) { s.parentNode.removeChild(s); });
    while (dst.firstChild) dst.removeChild(dst.firstChild);
    while (src.firstChild) dst.appendChild(document.adoptNode(src.firstChild));
  }
  function openDrawer() {
    setTimeout(function () {
      var qc = document.getElementById("quick_cart"); if (!qc) return;
      if (window.jQuery) window.jQuery(qc).trigger("click"); else qc.click();
    }, 100);
  }

  function addTrio(root) {
    if (!root || root.__ggBusy) return;
    render(root);
    var p = plan(root); if (!p || !p.ok) return;
    var d = p.d, btn = q(root, "[data-gg-trio-add]"), label = q(root, "[data-gg-trio-label]"), status = q(root, "[data-gg-trio-status]");
    root.__ggBusy = true;
    btn.disabled = true; btn.setAttribute("aria-busy", "true");
    if (label) label.textContent = d.strings.adding;
    if (status) status.textContent = "";
    var body = { items: p.ids.map(function (id) { return { id: id, quantity: 1 }; }), sections: ["cart-bubble", "cart-side"], sections_url: window.location.pathname };
    fetch(d.addUrl + ".js", {
      method: "POST", credentials: "same-origin",
      headers: { "Content-Type": "application/json", Accept: "application/json", "X-Requested-With": "XMLHttpRequest" },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) { return { ok: r.ok, j: j }; });
    }).then(function (res) {
      if (!res.ok) throw new Error(res.j.description || res.j.message || "");
      var sec = res.j.sections || {};
      swapInto(sec["cart-bubble"], ".float_count", "#quick_cart .float_count");
      swapInto(sec["cart-side"], ".side-panel-content", "#side-cart .side-panel-content");
      if (status) status.textContent = d.strings.added;
      openDrawer();
    }).catch(function (e) {
      var m = e && e.message ? String(e.message) : "";
      if (status) status.textContent = d.strings.error + (m ? " " + m : "");
    }).then(function () {
      root.__ggBusy = false;
      btn.removeAttribute("aria-busy");
      if (label) label.textContent = d.strings.button;
      render(root);
    });
  }

  function scan(scope) {
    var list = (scope && scope.querySelectorAll ? scope : document).querySelectorAll("[data-gg-trio]");
    for (var i = 0; i < list.length; i++) { list[i].__ggData = null; render(list[i]); }
  }

  document.addEventListener("click", function (e) {
    var t = e.target && e.target.closest ? e.target : null; if (!t) return;
    var add = t.closest("[data-gg-trio-add]");
    if (add) { e.preventDefault(); addTrio(add.closest("[data-gg-trio]")); return; }
    var sz = t.closest("[data-gg-size]");
    if (sz) {
      var g = sz.closest("[data-gg-guide]"); if (!g) return;
      var s = sz.getAttribute("data-gg-size");
      Array.prototype.forEach.call(g.querySelectorAll("[data-gg-size]"), function (b) { b.setAttribute("aria-pressed", String(b === sz)); });
      Array.prototype.forEach.call(g.querySelectorAll("[data-gg-rect]"), function (r) {
        if (r.getAttribute("data-gg-rect") === s) r.classList.add("is-active"); else r.classList.remove("is-active");
      });
      var st = g.querySelector("[data-gg-size-status]");
      if (st) st.textContent = fill(st.getAttribute("data-template"), { size: sizeText(s, "") });
    }
  });
  // Picker changes: cf-variant-ui sets the native selects and fires "change" on them.
  document.addEventListener("change", function (e) {
    if (e.target && e.target.closest && e.target.closest(".js-product-options")) setTimeout(function () { scan(); }, 0);
  }, true);
  // Theme editor: re-read a reloaded section; open a FAQ when its block is selected.
  document.addEventListener("shopify:section:load", function (e) { scan(e.target); });
  document.addEventListener("shopify:block:select", function (e) {
    var dt = e.target && e.target.closest ? e.target.closest("details.gg-pdp-faq__item") : null; if (dt) dt.open = true;
  });

  window.__ggPdp = { scan: scan };
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", function () { scan(); }); else scan();
})();
